import Cookies from "js-cookie";

import { IN_APP_LOGIN_KEY } from "@modules/common/constants";

export type InAppLogin = {
  accessCode: string;
  accessToken: string;
};

// Read the native-app auto-login cookie. hive-auth's `useAutoCookieFlow` owns
// authentication from this cookie; this reader is retained only for webview
// detection (e.g. opening links in `_self` vs `_blank`).
export const readInAppLoginCookie = (): InAppLogin | null => {
  const inAppLogin = Cookies.get(IN_APP_LOGIN_KEY);
  if (inAppLogin) {
    try {
      return JSON.parse(inAppLogin);
    } catch {
      return null;
    }
  }
  return null;
};

// Returns the native app platform from the autologin cookie ("ANDROID" or
// "iOS"), or undefined when running outside a native webview or before the
// MMP SDK has populated the field.
export const getPlatformFromCookie = (): string | undefined => {
  const raw = Cookies.get(IN_APP_LOGIN_KEY);
  if (raw) {
    try {
      return JSON.parse(raw).platform;
    } catch {
      return undefined;
    }
  }
  return undefined;
};
